export const Png = ({
  size = "20",
  ...props
}: { size?: string } & React.SVGProps<SVGSVGElement>) => {
  return (
    <>
      <span className="t-sr-only">Png</span>
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M3.57141 15.8928H4.68252C5.05088 15.8928 5.40415 15.7517 5.66462 15.5005C5.92508 15.2494 6.07141 14.9087 6.07141 14.5535C6.07141 14.1983 5.92508 13.8577 5.66462 13.6065C5.40415 13.3553 5.05088 13.2142 4.68252 13.2142H3.57141V16.9642"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3839 15.3571H17.0089V16.4868C16.8495 16.6351 16.6563 16.754 16.4414 16.8361C16.2265 16.9182 15.9942 16.9618 15.7589 16.9642C14.7238 16.9642 13.8839 16.1245 13.8839 15.0892C13.8839 14.054 14.7238 13.2142 15.7589 13.2142C16.0938 13.2151 16.4205 13.3026 16.6964 13.4653"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.57141 16.9642V13.2142L11.3393 16.9642V13.2142"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 10V3.125C3.75 2.95924 3.81585 2.80027 3.93306 2.68306C4.05027 2.56585 4.20924 2.5 4.375 2.5H11.875L16.25 6.875V10"
          fill="#EE82A3"
        />
        <path d="M11.875 2.5V6.875H16.25" fill="#BF517A" />
      </svg>
    </>
  );
};
